// import region ,react
import React, { useState, useMemo, useEffect } from "react";

// custom components
import { Card, CustomSpinner } from "_atoms";
import {
  BookingTable,
  AssistanceColumn,
  TableHeader,
  TableValue,
} from "_molecules";
import { PaginationClicker } from "_organisms";

// bootstrap //
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";

// libraries
import { add } from "date-fns";
import {
  Title as TremorTitle,
  Subtitle,
  Toggle,
  ToggleItem,
  Flex,
} from "@tremor/react";

// redux
import { useSelector, useDispatch } from "react-redux";
import {
  selectOrder,
  selectDateToISO,
} from "_redux/slices/prm-bookings/calendar";
import {
  getDepartures,
  departureList,
  selectDepartureStatus,
  selectDepartureSkip,
  getDeparturesCount,
  getDeparturesWithSearch,
} from "_redux/slices/prm-bookings/departures";
import {
  getArrivals,
  selectArrivalStatus,
  getArrivalsCount,
  getArrivalsWithSearch,
  selectArrivalsSkip,
} from "_redux/slices/prm-bookings/arrivals";
import * as arrivalsSlice from "_redux/slices/prm-bookings/arrivals";
import { selectUserDb } from "_redux/slices/main-screen/user";
import { selectIata } from "_redux/slices/main-screen/user";
import { selectAirlineSelectedAirport } from "_redux/slices/prm-bookings/bookings";
import {
  selectBookingTableType,
  setTable,
} from "_redux/slices/prm-bookings/bookings-table";
import {
  selectAnalyticsTypeSelector,
  getArrivalsForecast,
  getArrivalsCountForecast,
  getDeparturesCountForecast,
  getDeparturesForecast,
  getAnalyticsCountInboundByHourForForecast,
  getAnalyticsCountOutboundByHourForForecast,
} from "_redux/slices/prm-bookings/bookings-count";

//end region
const BookingsList = () => {
  function getBookings() {
    if (search) {
      dispatch(
        getDeparturesWithSearch(
          {
            iata: dbUser.details.type != "AIRLINE" ? iata : airport,
            start: date,
            end: date,
            limit: limit,
            skip: departureSkip,
            search: search,
            order: order,
            carrierCode: filter,
            source: analyticsTypeSelector,
          },
          controller.signal
        )
      );
      // get arrivals
      dispatch(
        getArrivalsWithSearch(
          {
            iata: dbUser.details.type != "AIRLINE" ? iata : airport,
            start: date,
            end: date,
            limit: limit,
            skip: arrivalSkip,
            search: search,
            order: order,
            carrierCode: filter,
            source: analyticsTypeSelector,
          },
          controller.signal
        )
      );
    } else {
      // get bookings count
      dispatch(
        getDeparturesCount(
          {
            iata: dbUser.details.type != "AIRLINE" ? iata : airport,
            start: date,
            end: date,
            limit: 1000,
            skip: 0,
            search: "",
            carrierCode: filter,
            order: order,
            type: "outbound",
            source: analyticsTypeSelector,
          },
          controller.signal
        )
      );
      dispatch(
        getArrivalsCount(
          {
            iata: dbUser.details.type != "AIRLINE" ? iata : airport,
            start: date,
            end: date,
            limit: 1000,
            skip: 0,
            search: "",
            carrierCode: filter,
            order: order,
            type: "inbound",
            source: analyticsTypeSelector,
          },
          controller.signal
        )
      );
      // get bookings
      dispatch(
        getDepartures(
          {
            iata: dbUser.details.type != "AIRLINE" ? iata : airport,
            start: date,
            end: date,
            limit: limit,
            skip: departureSkip,
            search: "",
            order: order,
            carrierCode: filter,
            source: analyticsTypeSelector,
          },
          controller.signal
        )
      );
      // get arrivals
      dispatch(
        getArrivals(
          {
            iata: dbUser.details.type != "AIRLINE" ? iata : airport,
            start: date,
            end: date,
            limit: limit,
            skip: arrivalSkip,
            search: "",
            order: order,
            carrierCode: filter,
            source: analyticsTypeSelector,
          },
          controller.signal
        )
      );

      // only get forecast if not connect bookings filter
      if (analyticsTypeSelector == "C" || dbUser.details.type === "AIRLINE") {
      } else {
        // get forecast
        dispatch(
          getDeparturesCountForecast(
            {
              iata: dbUser.details.type != "AIRLINE" ? iata : airport,
              start: date,
              end: date,
              limit: 1000,
              skip: 0,
              search: "",
              carrierCode: filter,
              order: order,
              type: "outbound",
              source: analyticsTypeSelector,
              forecast: true,
            },
            controller.signal
          )
        );
        dispatch(
          getArrivalsCountForecast(
            {
              iata: dbUser.details.type != "AIRLINE" ? iata : airport,
              start: date,
              end: date,
              limit: 1000,
              skip: 0,
              search: "",
              carrierCode: filter,
              order: order,
              type: "inbound",
              source: analyticsTypeSelector,
              forecast: true,
            },
            controller.signal
          )
        );
        // get bookings
        dispatch(
          getDeparturesForecast(
            {
              iata: dbUser.details.type != "AIRLINE" ? iata : airport,
              start: date,
              end: date,
              limit: 1000,
              skip: departureSkip,
              search: "",
              order: order,
              carrierCode: filter,
              source: analyticsTypeSelector,
              forecast: true,
            },
            controller.signal
          )
        );
        // get arrivals
        dispatch(
          getArrivalsForecast(
            {
              iata: dbUser.details.type != "AIRLINE" ? iata : airport,
              start: date,
              end: date,
              limit: 1000,
              skip: arrivalSkip,
              search: "",
              order: order,
              carrierCode: filter,
              source: analyticsTypeSelector,
              forecast: true,
            },
            controller.signal
          )
        );
      }
    }
  }

  // get daily bookings for csv file
  const getCSVData = () => {
    let countParams = {
      iata: dbUser.details.type == "AIRLINE" ? airport : iata,
      date: date,
      endDate: add(new Date(date), { days: 0 }).toISOString().split("T")[0],
      source: analyticsTypeSelector,
      airline:
        dbUser.details.type == "AIRLINE" ? dbUser.details.authority : null,
      byFlight: true,
    };
    if (dbUser.details.type !== "AIRLINE") {
      dispatch(getAnalyticsCountInboundByHourForForecast(countParams));
      dispatch(getAnalyticsCountOutboundByHourForForecast(countParams));
    }
  };

  //#region state + redux
  // state
  const dbUser = useSelector(selectUserDb);
  const limit = 100;

  // redux variables
  const dispatch = useDispatch();
  const date = useSelector(selectDateToISO); // selected date from calendar

  const analyticsTypeSelector = useSelector(selectAnalyticsTypeSelector); // 'source' (app/sita/portal) or 'none' (all bookings)

  // arrivals
  const arrivals = useSelector(arrivalsSlice.arrivalsList());
  const arrivalSkip = useSelector(selectArrivalsSkip);

  // departures
  const departures = useSelector(departureList());
  const departureSkip = useSelector(selectDepartureSkip);

  // table
  const type = useSelector(selectBookingTableType);
  const airport = useSelector(selectAirlineSelectedAirport);
  const order = useSelector(selectOrder);

  const controller = new AbortController();
  const iata = useSelector(selectIata);
  const [filter, setFilter] = useState(
    dbUser.details.type == "AIRLINE" ? iata : ""
  );
  //#endregion

  // loading
  const departureStatus = useSelector(selectDepartureStatus); // status of fetching bookings
  const arrivalStatus = useSelector(selectArrivalStatus); // status of fetching bookings
  const [search, setSearch] = useState("");

  // get list and count
  useEffect(() => {
    // if user exsists 
    if (dbUser) {
      getBookings();
      getCSVData();
    }
  }, [airport, date, analyticsTypeSelector]);

  // columns for table
  let columns = useMemo(
    () => [
      {
        Header: <div style={{ width: 20 }}></div>,
        accessor: "count",
        Cell: ({ cell: { value } }) => (
          <p style={{ opacity: 0.4, marginLeft: 10, marginTop: 5 }}>{value}</p>
        ),
      },
      {
        Header: <TableHeader title={"Name"} />,
        accessor: "name",
        Cell: ({ cell: { value } }) => <TableValue title={value} />,
      },
      {
        Header: <TableHeader title={"Flight"} />,
        accessor: "flightNumber",
        Cell: ({ cell: { value } }) => <TableValue title={value} />,
      },
      {
        Header: <TableHeader type={"time"} title={"Arrival"} />,
        accessor: "arrivalTime",
        Cell: ({ cell: { value } }) => <TableValue title={value} />,
      },
      {
        Header: <TableHeader type={"time"} title={"Departure"} />,
        accessor: "departureTime",
        Cell: ({ cell: { value } }) => <TableValue title={value} />,
      },
      {
        Header: <TableHeader title={"Due"} />,
        accessor: "dueTime",
        Cell: ({ cell: { value } }) => <TableValue title={value} />,
      },
      {
        Header: <TableHeader title={"Assistance"} />,
        accessor: "assistances",
        // render custom object
        Cell: ({ cell: { value } }) => <AssistanceColumn values={value} />,
      },
      {
        Header: <TableHeader title={"Required"} />,
        accessor: "leg1Assistance",
        // render custom object
        Cell: ({ cell: { value } }) => (
          <div>
            <TableValue title={value} comment={false} />
          </div>
        ),
      },
      {
        Header: <TableHeader title={"Transit"} />,
        accessor: "airport",
        Cell: ({ cell: { value } }) => <TableValue title={value} />,
      },
      {
        Header: <TableHeader title={"Required"} />,
        accessor: "leg2Assistance",
        // render custom object
        Cell: ({ cell: { value } }) => (
          <div>
            <TableValue title={value} />
          </div>
        ),
      },
      {
        Header: <TableHeader title={"Notes"} />,
        accessor: "bio",
        // render custom object
        Cell: ({ cell: { value } }) => (
          <div>
            <TableValue title={value} comment={true} />
          </div>
        ),
      },
      {
        Header: <TableHeader title={"Date Created"} />,
        accessor: "dateCreated",
        // render custom object
        Cell: ({ cell: { value } }) => (
          <div>
            <TableValue title={value} big={true} />
          </div>
        ),
      },
    ],
    [type]
  );

  return (
    <>
      {
        <Container className="mt-4" style={{ paddingBottom: 50 }}>
          <Card
            shadow={true}
            decoration="top"
            decorationColor={type == "Departures" ? "blue" : "green"}
          >
            <Row>
              <Col>
                <Flex>
                  {/* Title */}
                  <div>
                    <TremorTitle>Booking List</TremorTitle>
                    <Subtitle>
                      View the monthly bookings count split between departures
                      and arrivals
                    </Subtitle>
                  </div>

                  {/* Departures / Arrivals Switcher */}
                  <Toggle
                    color="zinc"
                    defaultValue={type}
                    onValueChange={(value) => dispatch(setTable(value))}
                  >
                    <ToggleItem value={"Departures"} text="Departures" />
                    <ToggleItem value={"Arrivals"} text="Arrivals" />
                  </Toggle>
                </Flex>
              </Col>
            </Row>

            {/* Booking Table */}
            {
              <>
                {
                  arrivalStatus == "loading" || departureStatus == "loading" ?
                    <Row className="justify-content-md-center mt-5">
                      <CustomSpinner />
                    </Row> :
                    <>
                      <body
                        style={{
                          overflowY: "scroll",
                          height: "40em",
                          display: "block"
                        }}
                      >
                        <BookingTable
                          columns={columns}
                          data={type == "Departures" ? departures : arrivals}
                        />
                      </body>

                      <PaginationClicker />
                    </>
                }
              </>
            }
          </Card>
        </Container>
      }
    </>
  );
};

export default BookingsList;
